import { useEffect, useState } from "react";
import { Button, Grid } from "@material-ui/core";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";
import Accordion from "components/_refactor/accordion";
import StructureFields from "components/_refactor/fields/structure";

const variableOptionsByType = {
  LK: [
    {
      label: "CodigoPedido",
      value: "CodigoPedido",
    },
    {
      label: "Link",
      value: "Link",
    },
  ],
  C360: [
    {
      label: "Nome",
      value: "Nome",
    },
  ],
  VITRINE: [
    {
      label: "Nome",
      value: "Nome",
    },
    {
      label: "Link",
      value: "Link",
    },
  ],
  CNF: [
    {
      label: "Nome do cliente",
      value: "NomeDoCliente",
    },
    {
      label: "Número da NF",
      value: "NumeroNF",
    },
    {
      label: "Data da venda",
      value: "DataVenda",
    },
    {
      label: "Link para download do PDF da nota fiscal",
      value: "LinkDownloadPDF",
    },
  ],
  PIX: [
    {
      label: "Nome do cliente",
      value: "nomeCliente",
    },
    {
      label: "Número do pedido",
      value: "numeroPedido",
    },
    {
      label: "Valor do pedido",
      value: "valorPedido",
    },
    {
      label: "Código PIX",
      value: "codigoPIX",
    },
  ],
  TEF: [
    {
      label: "Nome do cliente",
      value: "nomeCliente",
    },
    {
      label: "Nome da Loja",
      value: "nomeLoja",
    },
    {
      label: "Número do pedido",
      value: "numeroPedido",
    },
    {
      label: "Valor da Venda",
      value: "amount",
    },
    {
      label: "Data e Hora",
      value: "dateTime",
    },
    {
      label: "Bandeira do cartão",
      value: "cardBrand",
    },
    {
      label: "Código de autorização / NSU / TID",
      value: "authorizationCode",
    },
    {
      label: "Tipo de Transação",
      value: "transactionType",
    },
    {
      label: "Identificador da Transação",
      value: "transactionIdentifier",
    },
  ],
};

export default function ConfigurableCustomerContactMethod({
  title,
  templateOptions,
  type,
}) {
  const isMobile = IsMobile();

  const [structureFilters, setStructureFilters] = useState({});
  const [structureFiltersLoading, setStructureFiltersLoading] = useState(false);
  const [template, setTemplate] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [variables, setVariables] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isFetchingTemplate, setIsFetchingTemplate] = useState(false);

  const templateVariableCount =
    selectedTemplate?.text.match(/{{\d+}}/g)?.length || 0;

  const snackbar = useSnackbar();

  const handleUpdateTemplateVariables = async () => {
    try {
      setIsSaving(true);
      if (!template?.IdTemplateAgenda) {
        await Api.post(
          "schedule-template-create",
          "action",
          {
            idTemplate: selectedTemplate.objectId,
            jsonEstrutura: variables,
            idPessoaLoja: structureFilters.idLojaUnica,
            tipoEnvioContato: type,
          },
          true
        );
      } else {
        await Api.put(
          "schedule-template-edit",
          "action",
          {
            idTemplateAgenda: template.IdTemplateAgenda,
            idTemplate: selectedTemplate.objectId,
            jsonEstrutura: variables,
          },
          true
        );
      }
      snackbar.showMessage("Template atualizado com sucesso", {
        severity: "success",
      });
    } catch (error) {
      console.log(error);
      snackbar.showMessage(
        error?.response?.data?.ErrorMessage ||
          "Não foi possiver salvar configuração",
        {
          severity: "error",
        }
      );
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const getTemplateForType = async () => {
      if (!structureFilters.idLojaUnica) return;
      setIsFetchingTemplate(true);
      Api.get(
        "schedule-template-detail",
        "action",
        `?tipoEnvioContato=${type}&idPessoaLoja=${structureFilters.idLojaUnica}`,
        true
      )
        .then((res) => {
          if (res?.Result?.length > 0) {
            const template = res.Result[0];
            setTemplate(template);

            setSelectedTemplate(
              templateOptions?.find(
                (item) => item.objectId === template.IdTemplate
              )
            );
            setVariables(JSON.parse(template.JsonEstrutura || "{}"));
          }
        })

        .finally(() => setIsFetchingTemplate(false));
    };

    getTemplateForType();
  }, [structureFilters.idLojaUnica, type]);

  return (
    <Grid item xs={12}>
      <Accordion title={title}>
        <>
          <StructureFields
            onStructureFieldsChange={setStructureFilters}
            disableAll={false}
            onStructureFieldsLoad={setStructureFiltersLoading}
            requiredFields={["economicGroup", "singleStore"]}
            hideFields={["brand", "channel", "representative", "store"]}
            showSingleStore={true}
          />

          <Grid item xs={12}>
            <AutoCompleteField
              options={templateOptions}
              label="Template"
              value={selectedTemplate}
              onChange={setSelectedTemplate}
              loading={isFetchingTemplate}
              optionLabelKey="title"
              optionIdKey="objectId"
              disabled={isSaving || !structureFilters.idLojaUnica}
            />
          </Grid>
          {Array.from({ length: templateVariableCount }).map((_, index) => {
            return (
              <Grid key={index} item xs={12}>
                <AutoCompleteField
                  label={`{{${index + 1}}}`}
                  value={{
                    label: variables[index + 1],
                    value: variables[index + 1],
                  }}
                  disabled={isSaving}
                  onChange={(option) => {
                    setVariables((variables) => ({
                      ...variables,
                      [index + 1]: option.value,
                    }));
                  }}
                  options={variableOptionsByType[type] || []}
                  optionLabelKey="label"
                  optionIdKey="value"
                />
              </Grid>
            );
          })}

          <Grid item xs={12}>
            <Button
              style={
                isMobile
                  ? {
                      width: "100%",
                      marginBottom: "0.75rem",
                      marginTop: "0.75rem",
                    }
                  : { marginBottom: "0rem" }
              }
              variant="contained"
              disabled={
                isSaving ||
                isFetchingTemplate ||
                structureFiltersLoading.length > 0
              }
              onClick={handleUpdateTemplateVariables}
            >
              {isSaving ? "Atualizando..." : "Atualizar"}
            </Button>
          </Grid>
        </>
      </Accordion>
    </Grid>
  );
}
